<template>
  <a
    target="_blank"
    class="pega-input"
    :href="`${userUrl}/s/bko_reg/index.html`"
    data-test="provision-list-link"
  >登録情報規定一覧</a>
</template>

<script>
const USER_URL = process.env.USER_ENDPOINT

export default {
  computed: {
    userUrl: () => USER_URL // BOSS-Sからアクセスがある箇所はドメインから指定する必要があるため追加
  }
}
</script>
